import React from 'react';
import { Grid, Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import StarIcon from '@mui/icons-material/Star';
import Chip from '@mui/material/Chip';
import StatusTile, { StatusTileProps } from '@AMIEWEB/Unit/Common/StatusTile';
import { makeStyles } from 'tss-react/mui';
import { ISkillSetInfo } from '@AMIEWEB/Facility/FacilityStore/Facility.model';
import { transformUnitExperienceForStatusTile } from '../helper';

const useStyles = makeStyles()((theme: Theme) => ({
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  child: {
    paddingLeft: '12px',
  },
}));

const SkillSetTitle = ({ skillSetData, isPrimary }: { skillSetData: ISkillSetInfo; isPrimary: boolean }) => {
  const { classes } = useStyles();
  const { t: translation } = useTranslation();
  const transformSkillSet: StatusTileProps = transformUnitExperienceForStatusTile(skillSetData);

  return (
    <Grid container alignItems="center" justifyContent={'space-between'} columnSpacing={2}>
      <Grid className={classes.titleContainer}>
        {transformSkillSet && (
          <Grid item className={classes.child}>
            <StatusTile tileData={transformSkillSet} />
          </Grid>
        )}

        {skillSetData?.isSkillsCheckList && (
          <Grid item className={classes.child}>
            <Chip label={translation('facility.units.unitDetails.unitRequirements.skillsChecklist')} />{' '}
          </Grid>
        )}
        {skillSetData?.isNewGrad && (
          <Grid item className={classes.child}>
            <Chip label={translation('facility.units.experience.newGradTag')} />{' '}
          </Grid>
        )}

        {skillSetData?.isClinicalFellowship && (
          <Grid item className={classes.child}>
            <Chip label={translation('facility.units.unitDetails.unitRequirements.clinicalFellowship')} />{' '}
          </Grid>
        )}
      </Grid>

      {isPrimary && (
        <Grid item>
          <StarIcon
            sx={{
              fontSize: '24px',
            }}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default SkillSetTitle;
